import Consultations from 'features/consultations';
import { useTitle } from '../helpers';

/**
 * @page Consultations page
 */
const ConsultationsPage = () => {
  useTitle('Консультации');

  return (
    <div>
      <h3>Консультации</h3>
      <Consultations />
    </div>
  );
};

export default ConsultationsPage;
